export default __webpack_public_path__ + "static/TCP-2022-ESG-Report-Final-85d3db4e7e0d6e97bdfd2425839573c5.pdf";